import React from 'react'
import { RichTextDisplay } from '@ztechapps/webui.input'

export const TextTemplateDisplayValue = ({ value }) => {
  // trustedSource: template values are authored by staff in the admin app, not attacker-reachable
  return <RichTextDisplay as="pre" style={{ whiteSpace: 'pre-line' }} contentHtml={value} trustedSource />
}
